import { deepSearch } from 'helpers/search.js'
export function verticalCylinderVolume(diameter, height) {
    const radius = diameter / 2
    const volume = Math.PI * (radius * radius) * height
    return volume * 1000
}
export function verticalOvalVolume(width, length, height) {
    const radius = width / 2
    const area = Math.abs(length - width)
    const volume = (Math.PI * radius * radius + 2 * radius * area) * height
    return volume * 1000
}
export const tankVolume = obj => {
    if (!obj) return null
    try {
        const tShape = deepSearch(obj, 'tankShape') || null
        if (tShape && tShape === 'Vertical Cylinder Tank') {
            const tCap = parseFloat(deepSearch(obj, 'tankCapacity')) || 0
            const tDia = parseFloat(deepSearch(obj, 'tankDiameter')) || 0
            const tHgt = parseFloat(deepSearch(obj, 'tankHeight')) || 0
            const tLevel = parseFloat(deepSearch(obj, 'level')) || 0
            const tVolFull = tDia && tHgt ? Math.round(verticalCylinderVolume(tDia, tHgt)) : tCap ? tCap : 0
            const tFull = parseFloat(deepSearch(obj, 'maxLevel')) || 0

            const rtnObj = {
                level: tLevel,
                volume: tFull && tLevel ? (tCap ? Math.round((tLevel / tFull) * tCap) : Math.round((tLevel / tFull) * tVolFull)) : 0,
                volumeFull: tCap ? tCap : tVolFull,
                // volumeCap: tCap ? Math.round((tLevel / tFull) * tCap) : null,
                percent: Math.min(Math.max(tFull && tLevel ? parseFloat(((tLevel / tFull) * 100).toFixed(1)) : 0, 0), 100),
                fullHeight: tFull,
                maxVolumeEst: tVolFull,
                maxVolumeAct: tCap,
                name: obj.name,
            }
            return rtnObj
        }
        if (tShape && tShape === 'Vertical Oval Tank') {
            const tCap = parseFloat(deepSearch(obj, 'tankCapacity')) || null
            // const tDia = deepSearch(obj, "tankDiameter") || null
            const tHgt = parseFloat(deepSearch(obj, 'tankHeight')) || null
            const tWid = parseFloat(deepSearch(obj, 'tankWidth')) || null
            const tLen = parseFloat(deepSearch(obj, 'tankLength')) || null

            const tLevel = parseFloat(deepSearch(obj, 'level')) || null
            const tVolFull = tWid && tHgt && tLen ? Math.round(verticalOvalVolume(tWid, tLen, tHgt)) : tCap ? tCap : null
            const tFull = parseFloat(deepSearch(obj, 'maxLevel')) || null
            return {
                level: tLevel,
                volume: tFull && tLevel ? Math.round((tLevel / tFull) * tVolFull) : null,
                volumeFull: tVolFull,
                percent: tFull && tLevel ? parseFloat(((tLevel / tFull) * 100).toFixed(1)) : 0,
                fullHeight: tFull,
            }
        }
        if (obj && obj.type === 'waterTank') {
            const tCap = parseFloat(deepSearch(obj, 'tankCapacity')) || 0
            const tDia = parseFloat(deepSearch(obj, 'tankDiameter')) || 0
            const tHgt = parseFloat(deepSearch(obj, 'tankHeight')) || 0
            const tLevel = parseFloat(deepSearch(obj, 'level')) || 0
            const tVolFull = tDia && tHgt ? Math.round(verticalCylinderVolume(tDia, tHgt)) : tCap ? tCap : 0
            const tFull = parseFloat(deepSearch(obj, 'maxLevel')) || 0
            return {
                level: tLevel,
                volume: tFull && tLevel ? Math.round((tLevel / tFull) * tVolFull) : 0,
                volumeFull: tVolFull,
                percent: tFull && tLevel ? parseFloat(((tLevel / tFull) * 100).toFixed(1)) : 0,
                fullHeight: tFull,
                maxVolumeEst: tVolFull,
                maxVolumeAct: tCap,
            }
        }
        if (obj && obj.type === 'waterTrough') {
            const tLevel = parseFloat(deepSearch(obj, 'level')) || 0
            return {
                level: tLevel,
                percent: parseFloat(((tLevel / 190) * 100).toFixed(1)),
            }
        }
        if (obj && obj.type === 'waterDam') {
            const tLevel = Math.max(parseFloat(deepSearch(obj, 'level')) || 0, 0)
            const tFull = parseFloat(deepSearch(obj, 'maxLevel')) || 0
            let level = (tLevel / tFull) * 100
            return {
                level: tLevel,
                percent: level ? level.toFixed(1) : 0,
            }
        }
        return {
            level: 0,
            volume: 0,
            volumeFull: 0,
            percent: 0,
            fullHeight: 0,
            maxVolumeEst: 0,
            maxVolumeAct: 0,
        }
    } catch (err) {
        console.log(err)
        return {
            level: 0,
            volume: 0,
            volumeFull: 0,
            percent: 0,
            fullHeight: 0,
            maxVolumeEst: 0,
            maxVolumeAct: 0,
        }
    }
}
